import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { useSelector } from "react-redux";
import { IRootState } from "../../redux/store";
import { Button, Grid } from "@mui/material";
import { ButtonTextGrid } from "../..";
import { EditNote } from "@mui/icons-material";
import { createBooleanFilterOperators } from "../../util/UI";
import { RenderBooleanCell } from "../common/RenderBooleanCell";
import { ContractList } from "../../redux/staticInfo/state";
import { ContractInfo } from "../../redux/contract/state";

interface Props{
  openEditDialog:boolean
  handleClickEditButton:(contract:ContractList)=>void
}

function CurrentContract(props:Props) {
  const { contractList } = useSelector(
    (state: IRootState) => state.staticInfoState,
  );

  const columns: GridColDef[] = [
    {
      field: "contract_id",
      headerName: "具體編號",
      flex: 1,
    },
    {
      field: "contract",
      headerName: "合約名稱",
      flex: 5,
    },

    {
      field: "update_date",
      headerName: "更新時間",
      flex: 2,
      renderCell: (data) => (
        <div>
          {data.value ? new Date(parseInt(data.value)).toLocaleString() : null}
        </div>
      ),
    },

    {
      field: "username",
      headerName: "更新者",
      flex: 1,
    },

   {
      field: "is_active",
      headerName: "生效",
      flex: 1,
      filterOperators: createBooleanFilterOperators('is_active'),
      renderCell: RenderBooleanCell('is_active'),
    },

   {
      field: "need_inspect",
      headerName: "包含在巡查",
      flex: 1,
      filterOperators: createBooleanFilterOperators('need_inspect'),
      renderCell: RenderBooleanCell('need_inspect'),
    },

   

    {
      field: "edit",
      headerName: "修改紀錄",
      flex: 2,
      renderCell: (data) => (
        <div>
          <Button
            variant="contained"
            onClick={()=>props.handleClickEditButton(data.row)}
          >
            <ButtonTextGrid>
              <EditNote />
              <Grid>更改</Grid>
            </ButtonTextGrid>
          </Button>
        </div>
      ),
    },
  ];



  return (
    <div style={{ height: "900px", width: "100%" }}>
      <DataGrid
        rows={contractList || []}
        columns={columns}
        initialState={{
          pagination: {
            paginationModel: { page: 0, pageSize: 30 },
          },
        }}
        pageSizeOptions={[5, 10]}
        checkboxSelection
        getRowId={(row) => row.contract}
      />
    </div>
  );
}

export default CurrentContract;
